export default __webpack_public_path__ + "static/media/logo-white.1ea6dfc8.png";